import { render, staticRenderFns } from "./Digivihko.vue?vue&type=template&id=21b349cf&scoped=true"
import script from "./Digivihko.vue?vue&type=script&lang=js"
export * from "./Digivihko.vue?vue&type=script&lang=js"
import style0 from "./Digivihko.vue?vue&type=style&index=0&id=21b349cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b349cf",
  null
  
)

export default component.exports